import React, { useEffect, useState, useCallback } from 'react'
import { useFetch } from '../../api/FetchApiData';
import './users.css';
import UserOrders from '../orders/Orders';
import orders_icon from '../icons/orders.webp';
import payments_icon from '../icons/payments.svg';
import remove_icon from '../../icons/remove.webp';
import Popup from 'reactjs-popup';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useInfiniteScroll } from '../../utils/InfiniteScroll';
import { useTranslation } from 'react-i18next';


function OrdersPopUp({user})
{

    let _margin = '100px auto auto auto';
    let _with = '60%';
    let _height = ''
    if(isMobile)
    {
        _margin = '80px 0px auto 0px';
        _with = '95%';
    }

    return(<Popup trigger={
            <button style={{position:'relative',padding:'5px',marginRight:'10px',width:'55%',height:'30px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                <img src={orders_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                {
                    //<label style={{display:'block',padding:'5px 0px 5px 0px'}}>Commandes</label>
                }
                <span style={{position:'absolute',top:'-5px',right:'-5px',backgroundColor:'black',color:'white',borderRadius:'3px',padding:'3px 5px 3px 5px'}}>{0}</span>
            </button>}>
        {close=>(
            <fieldset style={{position:'fixed',top:'0px',display:'flex',flexDirection:'column',left:'0px',marginLeft:'0px',backgroundColor:'rgba(255,255,255,0.9)',width:'100%',height:'100vh'}}>
                <div style={{margin:_margin,marginBottom:'0px',position:'relative',width:_with,maxHeight:'80vh',overflowY:'auto',backgroundColor:'white'}}>
                    <UserOrders User={user} />
                </div>
                <input type='button' style={{height:'35px',margin:'auto',marginTop:'10px',color:'white',width:'50%',borderRadius:'5px',backgroundColor:'#f72727ff',border:'none'}} value={'Fermer'} onClick={e=>{close()}} />
            </fieldset>
        )}
    </Popup>);
}


function UserVitrine({user, setNotification}) {
    const [_user,setUser] = useState(user);
    const fetchData = useFetch();
    const [btnOrders,setBtnOrders] = useState(false);
    const navigator = useNavigate();
    const {t} = useTranslation();

    const update = ()=>
    {
        fetchData.PutData({'is_staff':_user.is_staff, id:_user.id},'user/users/').then((result)=>
            {
                if(result.result)
                {
                    setNotification({text:"l'utilisateur a été correctement mis à jour", display:'block', color:'green'});
                    setTimeout(()=>{
                        setNotification({text:"", display:'none', color:'black'});
                    }, 10000);
                }
                else
                {
                    setNotification({text:"l'utilisateur n'a pas été correctement mis à jour", display:'block', color:'orangered'});
                    setTimeout(()=>{
                        setNotification({text:"", display:'none', color:'black'});
                    }, 10000);
                }
            });
    }
    const Delete = ()=>
    {
        fetchData.DeleteData({id:_user.id},'user/users/').then((result)=>
            {

            });
    }

    let _with = "30%";
    if(isMobile)
        _with = "90%"

  return (
    <div className='user-vitrine' style={{display:'inline-block',textAlign:'left',marginRight:'5px',width:_with,fontSize:'small'}}>
        <h4 style={{marginBottom:'5px',width:'100%',textAlign:'center',fontSize:'x-small'}}>{_user.labelname}</h4>
        <div style={{fontSize:'x-small',textAlign:'left',display:'inline-block',width:'80%',verticalAlign:'middle'}}>
            <div style={{marginBottom:'10px'}}>
                <span style={{marginLeft:'20px',fontWeight:'bold'}}>{t('authentication.telephone')}</span><span> {_user.phone}</span>
            </div>
            <div style={{marginBottom:'10px'}}>
                <span style={{marginLeft:'20px',marginRight:'10px',fontWeight:'bold'}}>{t('authentication.email')} </span><span>{_user.email}</span>
            </div>
            <div style={{marginBottom:'10px'}}>
                <span style={{marginLeft:'20px',fontWeight:'bold'}}>Solde du Compte :</span><span style={{color:'green',fontWeight:'bolder'}}> {'0 Euros'}</span>
            </div>
            <div style={{marginBottom:'10px',display:'flex',flexDirection:'row',justifyItems:'center',alignItems:'center'}}>
                <span style={{marginLeft:'20px',fontWeight:'bold',width:'100px'}}>Staff : </span>
                <input style={{marginLeft:'0px',}} type='checkbox' onChange={e=>{setUser({..._user,is_staff:e.target.checked})}} defaultChecked={_user.is_staff} />
            </div>
        </div>
        <div style={{marginTop:'10px',marginBottom:'10px',display:'inline-block',width:'20%',verticalAlign:'middle'}}>
            <div style={{width:'100%',marginBottom:'5px'}}>
                <OrdersPopUp user={user} />
            </div>
            <div style={{width:'100%',marginBottom:'5px'}}>
                <button onClick={e=>{navigator('/user/orders/')}} style={{position:'relative',padding:'5px',marginRight:'3px',width:'55%',height:'30px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                    <img src={payments_icon} style={{width:'15px',display:'block',margin:'auto'}} />
                    {
                        //<label style={{display:'block',padding:'5px 0px 5px 0px',fontSize:'xx-small'}}>Paiements</label>
                    }
                    </button>
            </div>
            <div style={{width:'100%',marginBottom:'5px'}}>
                <button onClick={e=>{Delete()}} style={{position:'relative',padding:'5px',marginRight:'3px',width:'55%',height:'30px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                    <img src={remove_icon} style={{width:'15px',display:'block',margin:'auto'}} />
                    {
                    
                    //<label style={{display:'block',padding:'5px 0px 5px 0px',fontSize:'xx-small'}}>Supprimer</label>
                    }
                </button>
            </div>
        </div>
        <div style={{width:'100%',textAlign:'center'}}>
            <input onClick={e=>{update()}} type='button' style={{height:'30px',marginRight:'10px',width:'40%',marginTop:'5px',border:'none',fontSize:'x-small',marginBottom:'5px',backgroundColor:'lightgreen',paddingLeft:'20px',paddingRight:'20px',borderRadius:'10px'}} value={'Enregistrer'} />
        </div>
    </div>
  )
}


function Users() {
    const [users, setUsers] = useState([]);
    const [notification,setNotification] = useState({text:'', color:'black', display:'none'})
    const fetchData = useFetch();

    const [page,setPage] = useState({CurrentPage:1,MaxPage:1});
    const [hasMore,setHasMore] = useState(true);

    const FetchDelivers = useCallback(async ()=>{
        if(page.CurrentPage<=page.MaxPage)
        {
                fetchData.PostData({'page':page.CurrentPage},'user/users/').then((result)=>{
                    if(result.result)
                    {
                        if(page.CurrentPage>result.maxpage)
                            setHasMore(false);
                        else
                        {setUsers([...users,...result.users]);setPage({...page,CurrentPage:page.CurrentPage+1,MaxPage:result.maxpage});}
                    }
                })
            }
    },[page.CurrentPage]);

    const LoadMoreRef = useInfiniteScroll(FetchDelivers,hasMore);

    useEffect(()=>{
        /*
        fetchData.PostData({},'user/users/').then((result)=>{
            if(result.result)
                setUsers([...result.users])
        })
        */
    },[])

  return (
    <div className='users'>
        <div style={{display:notification.display}}>
            <p style={{color:notification.color}}>{notification.text}</p>
        </div>
        {
            users.map((user,index)=>{
                return(<UserVitrine user={user} key={index} setNotification={setNotification} />)})
        }
        <div ref={LoadMoreRef} style={{height:'20px'}}/>
    </div>
  )
}

export default Users
